// extracted by mini-css-extract-plugin
module.exports = {"footerRow":"Footer_footerRow__3C1gi","footerActions":"Footer_footerActions__12TDN","logoTootor":"Footer_logoTootor__3GcIK","footerLegalese":"Footer_footerLegalese__3z62S"};